import {NgModule} from '@angular/core';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NZ_ICON_DEFAULT_TWOTONE_COLOR, NZ_ICONS, NzIconModule} from 'ng-zorro-antd/icon';
import {NzGridModule} from 'ng-zorro-antd/grid';
import {NzLayoutModule} from 'ng-zorro-antd/layout';
import {NzAffixModule} from 'ng-zorro-antd/affix';
import {NzBreadCrumbModule} from 'ng-zorro-antd/breadcrumb';
import {NzDropDownModule} from 'ng-zorro-antd/dropdown';
import {NzMenuModule} from 'ng-zorro-antd/menu';
import {NzPaginationModule} from 'ng-zorro-antd/pagination';
import {NzStepsModule} from 'ng-zorro-antd/steps';
import {NzCascaderModule} from 'ng-zorro-antd/cascader';
import {NzCheckboxModule} from 'ng-zorro-antd/checkbox';
import {NzDatePickerModule} from 'ng-zorro-antd/date-picker';
import {NzFormModule} from 'ng-zorro-antd/form';
import {NzInputModule} from 'ng-zorro-antd/input';
import {NzMentionModule} from 'ng-zorro-antd/mention';
import {NzRadioModule} from 'ng-zorro-antd/radio';
import {NzRateModule} from 'ng-zorro-antd/rate';
import {NzSelectModule} from 'ng-zorro-antd/select';
import {NzSliderModule} from 'ng-zorro-antd/slider';
import {NzSwitchModule} from 'ng-zorro-antd/switch';
import {NzTimePickerModule} from 'ng-zorro-antd/time-picker';
import {NzTransferModule} from 'ng-zorro-antd/transfer';
import {NzUploadModule} from 'ng-zorro-antd/upload';
import {NzAvatarModule} from 'ng-zorro-antd/avatar';
import {NzBadgeModule} from 'ng-zorro-antd/badge';
import {NzCalendarModule} from 'ng-zorro-antd/calendar';
import {NzCardModule} from 'ng-zorro-antd/card';
import {NzCarouselModule} from 'ng-zorro-antd/carousel';
import {NzCollapseModule} from 'ng-zorro-antd/collapse';
import {NzListModule} from 'ng-zorro-antd/list';
import {NzPopoverModule} from 'ng-zorro-antd/popover';
import {NzTableModule} from 'ng-zorro-antd/table';
import {NzTabsModule} from 'ng-zorro-antd/tabs';
import {NzTagModule} from 'ng-zorro-antd/tag';
import {NzTimelineModule} from 'ng-zorro-antd/timeline';
import {NzToolTipModule} from 'ng-zorro-antd/tooltip';
import {NzTreeModule} from 'ng-zorro-antd/tree';
import {NzAlertModule} from 'ng-zorro-antd/alert';
import {NzMessageModule} from 'ng-zorro-antd/message';
import {NzModalModule} from 'ng-zorro-antd/modal';
import {NzProgressModule} from 'ng-zorro-antd/progress';
import {NzSpinModule} from 'ng-zorro-antd/spin';
import {NzAnchorModule} from 'ng-zorro-antd/anchor';
import {NzBackTopModule} from 'ng-zorro-antd/back-top';
import {NzDividerModule} from 'ng-zorro-antd/divider';
import {NzAutocompleteModule} from 'ng-zorro-antd/auto-complete';
import {NzInputNumberModule} from 'ng-zorro-antd/input-number';
import {NzNotificationModule} from 'ng-zorro-antd/notification';
import {NzPageHeaderModule} from 'ng-zorro-antd/page-header';
import {NzStatisticModule} from 'ng-zorro-antd/statistic';
import {NzSpaceModule} from 'ng-zorro-antd/space';
import {NzDrawerModule} from 'ng-zorro-antd/drawer';
import {NzEmptyModule} from 'ng-zorro-antd/empty';
import {NzTypographyModule} from 'ng-zorro-antd/typography';
import {NzDescriptionsModule} from 'ng-zorro-antd/descriptions';
import {NzSkeletonModule} from 'ng-zorro-antd/skeleton';
import {IconDefinition} from '@ant-design/icons-angular';
import {NzImageModule} from 'ng-zorro-antd/image';
import {
  AccountBookFill,
  AlertFill,
  AlertOutline,
  ArrowDownOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  BookFill,
  BookOutline,
  CalendarFill,
  CalendarOutline,
  CaretLeftFill,
  CaretLeftOutline,
  CaretRightFill,
  CaretRightOutline,
  CheckCircleFill,
  CheckOutline,
  CloseCircleFill,
  CloseOutline,
  CopyFill,
  CopyOutline,
  DeleteFill,
  DeleteOutline,
  DownloadOutline,
  DownOutline,
  EditFill,
  EditOutline,
  EllipsisOutline,
  ExceptionOutline,
  EyeFill,
  EyeInvisibleFill,
  EyeInvisibleOutline,
  EyeOutline,
  FileDoneOutline,
  InfoCircleFill,
  InfoCircleOutline,
  LeftOutline,
  MenuFoldOutline,
  MenuOutline,
  MenuUnfoldOutline,
  PhoneFill,
  PhoneOutline,
  PlusCircleFill,
  PlusCircleOutline,
  ReloadOutline,
  RightOutline,
  SaveFill,
  SaveOutline,
  SearchOutline,
  SendOutline,
  ShopFill,
  ShopOutline,
  SortAscendingOutline,
  SortDescendingOutline,
  UpOutline,
  UserAddOutline
} from '@ant-design/icons-angular/icons';

const icons: IconDefinition[] = [
  AccountBookFill, AlertFill, AlertOutline, EllipsisOutline, EyeOutline, EyeFill, DeleteFill, DeleteOutline, EditFill,
  EditOutline, CloseOutline, CloseCircleFill, CheckOutline, CheckCircleFill, PlusCircleFill, PlusCircleOutline, BookFill, BookOutline,
  CaretLeftFill, CaretLeftOutline, CaretRightFill, CaretRightOutline, MenuOutline, DownOutline, InfoCircleOutline, InfoCircleFill,
  FileDoneOutline, PhoneOutline, PhoneFill, SaveFill, SaveOutline, CalendarFill, CalendarOutline, ShopFill, ShopOutline, UserAddOutline,
  CopyFill, CopyOutline, ArrowRightOutline, ArrowLeftOutline, ArrowDownOutline, EyeInvisibleFill, EyeInvisibleOutline, ExceptionOutline,
  ReloadOutline, SendOutline, UpOutline, SearchOutline, DownloadOutline, SortAscendingOutline, SortDescendingOutline, LeftOutline,
  RightOutline, MenuUnfoldOutline, MenuFoldOutline
];

@NgModule({
  imports: [
    NzIconModule,
  ],
  exports: [
    NzIconModule,
    NzButtonModule,
    NzGridModule,
    NzLayoutModule,
    NzAffixModule,
    NzBreadCrumbModule,
    NzDropDownModule,
    NzMenuModule,
    NzPaginationModule,
    NzStepsModule,
    NzAutocompleteModule,
    NzCascaderModule,
    NzCheckboxModule,
    NzDatePickerModule,
    NzFormModule,
    NzInputModule,
    NzInputNumberModule,
    NzMentionModule,
    NzRadioModule,
    NzRateModule,
    NzSelectModule,
    NzSliderModule,
    NzSwitchModule,
    NzTimePickerModule,
    NzTransferModule,
    NzUploadModule,
    NzAvatarModule,
    NzBadgeModule,
    NzCalendarModule,
    NzCardModule,
    NzCarouselModule,
    NzCollapseModule,
    NzListModule,
    NzPopoverModule,
    NzTableModule,
    NzTabsModule,
    NzTagModule,
    NzTimelineModule,
    NzToolTipModule,
    NzTreeModule,
    NzAlertModule,
    NzMessageModule,
    NzModalModule,
    NzNotificationModule,
    NzPopoverModule,
    NzProgressModule,
    NzSpinModule,
    NzAnchorModule,
    NzBackTopModule,
    NzDividerModule,
    NzPageHeaderModule,
    NzStatisticModule,
    NzSpaceModule,
    NzDrawerModule,
    NzEmptyModule,
    NzTypographyModule,
    NzDescriptionsModule,
    NzSkeletonModule,
    NzImageModule,
  ],
  providers: [
    { provide: NZ_ICON_DEFAULT_TWOTONE_COLOR, useValue: '#00ff00' },
    { provide: NZ_ICONS, useValue: icons }
  ]
})
export class ExternalModule { }
